import { Helmet } from "react-helmet-async";
import { useLang } from "../i18n";
import { SITE_URL } from "../data/site";

export default function Seo({ title, desc, path = "", jsonLd, image }) {
  const { lang } = useLang();
  const prefix = lang === "ca" ? "/ca" : "";
  const url = `${SITE_URL}${prefix}${path}`;
  const altUrl = lang === "ca" ? `${SITE_URL}${path}` : `${SITE_URL}/ca${path}`;

  return (
    <Helmet htmlAttributes={{ lang }}>
      <title>{title}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <link rel="alternate" hrefLang={lang === "ca" ? "ca" : "es"} href={url} />
      <link rel="alternate" hrefLang={lang === "ca" ? "es" : "ca"} href={altUrl} />
      <link rel="alternate" hrefLang="x-default" href={`${SITE_URL}${path}`} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={desc} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}

export const ORG_LD = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: "EcoGlow Detailing",
  description:
    "Detailing profesional en Els Muntells, Tarragona. Limpieza interior y exterior, pulido, corrección de pintura, Fusso Coat y tratamiento cerámico.",
  telephone: "+34691622449",
  url: SITE_URL,
  image: "https://images.unsplash.com/photo-1567808291548-fc3ee04dbcf0?crop=entropy&cs=srgb&fm=jpg&q=85",
  address: {
    "@type": "PostalAddress",
    addressLocality: "Els Muntells",
    addressRegion: "Tarragona",
    addressCountry: "ES",
  },
  areaServed: ["Els Muntells", "Amposta", "Deltebre", "Sant Jaume d'Enveja", "La Ràpita", "Tortosa"],
  sameAs: [],
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "5.0",
    reviewCount: "9",
  },
};

export function serviceLd(name, desc, path) {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    name,
    description: desc,
    provider: { "@type": "LocalBusiness", name: "EcoGlow Detailing", telephone: "+34691622449" },
    areaServed: ["Els Muntells", "Amposta", "Deltebre", "Sant Jaume d'Enveja", "La Ràpita", "Tortosa"],
    url: `${SITE_URL}${path}`,
  };
}

export function breadcrumbLd(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: `${SITE_URL}${it.path}`,
    })),
  };
}
